/* 倒计时 mixins
 * @Author: wjl 
 * @Date: 2019-06-28 16:09:46 
 * @Last Modified by: wjl
 * @Last Modified time: 2019-06-28 16:15:41
 */

<script>
export default {
  name: '',
  data () {
    return {
      timer: null,
      show: true,
      count: ""
    };
  }, 
  methods: {
    setTimer() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    }
  }
}
</script>

<style lang="scss" module>
</style>